<template>
  <el-dialog title="自定义运单标签内容" :visible.sync="dialogFormVisible" :modal="false">
    <el-form label-width="120px">
      <el-form-item label="面单标签LOGO">
        <el-upload :headers="{authorization:token}" :action="`${path}customer/uploadImage`" list-type="picture-card"
          :on-remove="handleRemove" :on-success="successUpload" :before-upload="beforeAvatarUpload"
          :on-error="errorUpload" :limit="1" :file-list="fileList">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="面单标签文字">
        <el-input type="textarea" rows="4" v-model="formData.companyText" maxlength="18" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="原产地配置">
        <el-select v-model="formData.originCountry">
          <el-option v-for="item in originCountryList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {
    mapGetters
  } from 'vuex';
  import globalData from '@/utils/config';
  import {
    customerSetLogo
  } from '@/api/user' // get token from cookie
  import {
    getToken
  } from '@/utils/auth'
  export default {
    computed: {
      ...mapGetters(['userInfo'])
    },
    data() {
      return {
        path: globalData.path,
        dialogFormVisible: false,
        formData: {
          companyText: '',
          companyLogo: '',
          originCountry: ''
        },
        dialogImageUrl: '',
        token: getToken(),
        fileList: [],
        originCountryList: [{value: 'China',
          label: 'China'},{value: 'Vietnam',
          label: 'Vietnam'},{value: 'CAMBODIA',
          label: 'CAMBODIA'},{value: 'PHILIPPINES',
          label: 'PHILIPPINES'}]
      }
    },
    mounted() {
      this.formData.companyText = this.userInfo.companyText
      this.formData.companyLogo = this.userInfo.companyLogo
      if (this.formData.companyLogo) {
        this.fileList = [{
          name: 'logo',
          url: globalData.fileUrl + this.formData.companyLogo
        }]
      }
    },
    methods: {

      handleRemove() {
        this.fileList = []
        this.formData.companyLogo = ''
      },
      successUpload(res) {
        if (res.code == 200) {
          this.formData.companyLogo = res.fileUrl
        } else {
          this.fileList = []
          this.formData.companyLogo = ''
          return this.$message.warning('上传失败');
        }
      },
      errorUpload() {
        return this.$message.warning(`上传失败`);
      },
      beforeAvatarUpload(file) {
        const isImg = file.type.includes('image/')
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isImg) {
          this.$message.error('面单标签LOGO只能是图片!');
        }
        if (!isLt2M) {
          this.$message.error('上传面单标签LOGO图片大小不能超过 2MB!');
        }
        return isImg && isLt2M;
      },
      async submitForm() {
        let {
          code,
          mass
        } = await customerSetLogo(this.formData)
        if (code == 200) {
          this.$message.success(mass)
          this.dialogFormVisible=false
        } else {
          this.$message.error(mass)
        }
      }

    }
  }

</script>
<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

</style>
